import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateCarbonProgramDraft } from "services";

import { GET_CARBON_PROGRAM_DRAFT, GET_CARBON_PROGRAM_DRAFTS, UPDATE_CARBON_PROGRAM_DRAFT } from "consts";

export const useUpdateCarbonProgramDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [UPDATE_CARBON_PROGRAM_DRAFT],
    mutationFn: updateCarbonProgramDraft,
    onSuccess: (draft) => {
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_DRAFTS] });
      queryClient.setQueryData([GET_CARBON_PROGRAM_DRAFT, draft.id], draft);
    },
  });
};
